import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from '../components/Modal';
import { supabase } from '../config/supabase';

const GoldRegister = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    surname: '',
    dob: '',
    idNumber: '',
    email: '',
    password: '',
    confirmPassword: '',
    paymentOption: ''
  });
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match!');
      return;
    }

    try {
      setError('');
      
      const { data: authData, error: authError } = await supabase.auth.signUp({
        email: formData.email,
        password: formData.password,
        options: {
          data: {
            full_name: `${formData.name} ${formData.surname}`,
            membership_tier: 'Gold'
          }
        }
      });

      if (authError) {
        setError(authError.message);
        return;
      }

      const { error: userError } = await supabase
        .from('users')
        .insert([{
          id: authData.user.id,
          email: formData.email,
          full_name: `${formData.name} ${formData.surname}`,
          membership_tier: 'Gold',
          status: 'pending'
        }]);

      if (userError) {
        setError(userError.message);
        return;
      }

      const { error: formError } = await supabase
        .from('application_forms')
        .insert([{
          user_id: authData.user.id,
          first_name: formData.name,
          last_name: formData.surname,
          email: formData.email,
          date_of_birth: formData.dob,
          membership_tier: 'Gold',
          status: 'pending',
          areas_of_interest: formData.paymentOption ? [`Payment: ${formData.paymentOption}`] : []
        }]);

      if (formError) {
        setError(formError.message);
        return;
      }

      setShowModal(true);
      
    } catch (err) {
      setError(err.message || 'An error occurred during registration');
    }
  };

  return (
    <div className="page-container">
      <div className="page-wrapper">
        <div className="logo-container" style={{textAlign: 'center', marginBottom: '1.5rem'}}>
          <img src="/images/IBVlogo.png" alt="IBV Wealth Club" style={{maxWidth: '150px', height: 'auto'}} />
        </div>

        <div className="card">
          <h2 className="section-title">Gold Package Registration</h2>
          <p className="page-subtitle">Unlock premium benefits with our Gold membership.</p>
          
          <div className="mb-lg">
            <strong>Options:</strong>
            <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
              <li>R500/month or R6000/year (Existing IBV Vault Clients)</li>
              <li>R1000/month or R12000/year (Includes Vault)</li>
              <li style={{ fontSize: '12px', color: '#666' }}>Prices exclude R50 card fee & SPM fees</li>
            </ul>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                name="name"
                className="form-input"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <input
                type="text"
                name="surname"
                className="form-input"
                placeholder="Surname"
                value={formData.surname}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <input
                type="date"
                name="dob"
                className="form-input"
                value={formData.dob}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <input
                type="text"
                name="idNumber"
                className="form-input"
                placeholder="ID Number"
                value={formData.idNumber}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <input
                type="email"
                name="email"
                className="form-input"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <input
                type="password"
                name="password"
                className="form-input"
                placeholder="Create Password"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <input
                type="password"
                name="confirmPassword"
                className="form-input"
                placeholder="Confirm Password"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <select
                name="paymentOption"
                className="form-select"
                value={formData.paymentOption}
                onChange={handleChange}
                required
              >
                <option value="">Select Payment Option</option>
                <option value="R500/month - Existing Vault Client">R500/month (Existing Vault Client)</option>
                <option value="R6000/year - Existing Vault Client">R6000/year (Existing Vault Client)</option>
                <option value="R1000/month - Includes Vault">R1000/month (Includes Vault)</option>
                <option value="R12000/year - Includes Vault">R12000/year (Includes Vault)</option>
              </select>
            </div>

            {error && <div className="alert alert-error">{error}</div>}

            <button type="submit" className="btn btn-primary">
              Submit Application
            </button>

            <button 
              type="button" 
              className="btn btn-secondary mt-md"
              onClick={() => navigate('/register')}
            >
              Back to Packages
            </button>
          </form>
        </div>

        <Modal isOpen={showModal} onClose={() => navigate('/login')}>
          <p>Thank you. Your application is being verified.</p>
          <p>We will contact you in 3–5 business days.</p>
          <button className="btn btn-primary mt-lg" onClick={() => navigate('/login')}>
            OK
          </button>
        </Modal>
      </div>
    </div>
  );
};

export default GoldRegister;
